import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FaqContent } from './FaqContent';

/**
 * The FAQ as read at the issue desk. Content is preloaded with the page rather
 * than fetched on open, so an issuer with a runner waiting gets it instantly.
 */
export const FaqModal = ({ isOpen, toggle, loading, faq, eventName }) => (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable>
        <ModalHeader toggle={toggle}>
            <i className="mdi mdi-help-circle-outline me-1"></i>
            FAQ{eventName ? ' - ' + eventName : ''}
        </ModalHeader>
        <ModalBody>
            <FaqContent loading={loading} faq={faq} />
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" onClick={toggle}>Close</Button>
        </ModalFooter>
    </Modal>
);
